module.exports = __webpack_public_path__ + "img/loan-percent.57c6a936.svg";